(() => {
  if (window.AnessaCart) return;
  let config, drawer, previousFocus, currentCart, busy = false, savedOverflow = '';
  const declinedGifts = new Set();
  const giftFor = item => config.gifts?.find(g => Number(g.id) === Number(item.variant_id));
  const briefCount = data => data.items.reduce((n,item) => n + (Number(item.product_id) === Number(config.briefId) ? item.quantity : 0), 0);
  const surfaces = () => [...document.querySelectorAll('[data-anessa-cart-surface]')];
  const node = (tag, text, className) => { const n = document.createElement(tag); if (text !== undefined) n.textContent = text; if (className) n.className = className; return n; };
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currentCart?.currency || config.currency || 'USD' }).format(value / 100);
  function status(message) { document.querySelectorAll('[data-anessa-cart-status]').forEach(n => n.textContent = message); }
  function error(message = '') { document.querySelectorAll('[data-anessa-cart-error]').forEach(n => { n.textContent = message; n.hidden = !message; }); }
  function lock(value) {
    busy = value;
    surfaces().forEach(surface => {
      surface.setAttribute('aria-busy', String(value));
      surface.querySelectorAll('[data-ac-change], [data-ac-add], [data-anessa-checkout]').forEach(n => n.disabled = value || (n.hasAttribute('data-anessa-checkout') && !currentCart?.items.length));
    });
    if (value) status(config.strings.loading);
  }
  async function request(endpoint, body) {
    const response = await fetch(config.root + endpoint, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}) });
    let data;
    try { data = await response.json(); } catch { throw new Error(config.strings.error); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : config.strings.error);
    return data;
  }
  async function syncGifts(data) {
    if (!config.gifts?.length) return data;
    const count = briefCount(data), updates = {}, additions = [];
    for (const gift of config.gifts) {
      const lines = data.items.filter(item => Number(item.variant_id) === Number(gift.id));
      const eligible = count >= gift.minimum && !declinedGifts.has(gift.id);
      lines.forEach((item,index) => { const wanted = eligible && index === 0 ? 1 : 0; if (item.quantity !== wanted) updates[item.key] = wanted; });
      if (eligible && !lines.length) additions.push({id:gift.id,quantity:1,properties:{_anessa_gift:'bundle'}});
    }
    if (Object.keys(updates).length) data = await request('cart/update.js', {updates});
    if (additions.length) { await request('cart/add.js', {items:additions}); data = await request('cart.js'); }
    return data;
  }
  function renderExtras(surface,data) {
    const extras = surface.querySelector('[data-anessa-cart-extras]'); if (!extras) return;
    extras.replaceChildren(); if (!briefCount(data)) return;
    const gifts = (config.gifts || []).filter(gift => !data.items.some(item => Number(item.variant_id) === Number(gift.id)));
    if (gifts.length) {
      const box = node('section', undefined, 'ac-gifts'); box.append(node('h3',config.strings.gifts_title));
      const cards = node('div',undefined,'ac-gift-grid');
      gifts.forEach(gift => {
        const included = data.items.some(item => Number(item.variant_id) === Number(gift.id));
        const eligible = briefCount(data) >= gift.minimum;
        const card = node('div',undefined,'ac-gift-card' + (included ? ' is-included' : ''));
        const img = node('img');img.src=gift.image;img.alt=gift.title;img.width=64;img.height=76;img.loading='lazy';card.append(img);
        card.append(node('strong',gift.title),node('span',included ? config.strings.free : config.strings.unlock.replace('{count}',Math.max(0,gift.minimum-briefCount(data)))));
        if (eligible && !included) { const btn=node('button',config.strings.add,'ac-extra-add');btn.type='button';btn.dataset.acAdd='gift';btn.addEventListener('click',()=>{declinedGifts.delete(gift.id);openPage();});card.append(btn); }
        cards.append(card);
      });box.append(cards);extras.append(box);
    }
    const brush = config.brush;
    if (brush && !data.items.some(item => Number(item.variant_id) === Number(brush.id))) {
      const box=node('section',undefined,'ac-upsell');box.append(node('h3',config.strings.upsell_title));
      const card=node('div',undefined,'ac-upsell-card');const img=node('img');img.src=brush.image;img.alt=brush.title;img.width=80;img.height=80;img.loading='lazy';card.append(img);
      const details=node('div',undefined,'ac-upsell-info');details.append(node('strong',brush.title),node('p',config.strings.brush_description));
      const prices=node('div',undefined,'ac-price');if(brush.compare>brush.price)prices.append(node('s',money(brush.compare)));prices.append(node('strong',money(brush.price)));details.append(prices);card.append(details);
      const btn=node('button',config.strings.add,'ac-extra-add');btn.type='button';btn.dataset.acAdd='brush';btn.addEventListener('click',()=>add([{id:brush.id,quantity:1}]).catch(e=>error(e.message||config.strings.error)));card.append(btn);box.append(card);extras.append(box);
    }
  }
  function render(data) {
    currentCart = data;
    document.querySelectorAll('[data-cart-count]').forEach(n => n.textContent = data.item_count);
    surfaces().forEach(surface => {
      const list = surface.querySelector('[data-anessa-cart-items]');
      list.replaceChildren();
      if (!data.items.length) {
        const empty = node('div', undefined, 'ac-empty'); empty.append(node('p', config.strings.empty));
        const link = node('a', config.strings.continue, 'ac-shop'); link.href = config.productUrl; empty.append(link); list.append(empty);
      }
      data.items.slice().sort((a,b) => Number(Boolean(giftFor(a))) - Number(Boolean(giftFor(b)))).forEach(item => {
        const gift = giftFor(item);
        const row = node('article', undefined, 'ac-row' + (gift ? ' ac-row-gift' : '')); 
        if (item.image) { const img = node('img'); img.src = gift?.image || item.image + (item.image.includes('?') ? '&' : '?') + 'width=180'; img.alt = item.product_title; img.width = 88; img.height = 104; img.loading = 'lazy'; row.append(img); }
        const details = node('div', undefined, 'ac-details');
        const heading = node('h3'); const link = node(gift ? 'span' : 'a', gift?.title || item.product_title); if (!gift) link.href = item.url; heading.append(link); details.append(heading);
        if (item.variant_title && item.variant_title !== 'Default Title') details.append(node('p', item.variant_title, 'ac-variant'));
        const prices = node('p', undefined, 'ac-price');
        if (item.original_line_price > item.final_line_price) prices.append(node('s', money(item.original_line_price)));
        prices.append(node('strong', gift && item.final_line_price === 0 ? config.strings.free : money(item.final_line_price))); row.append(prices);
        if(gift) details.append(node('p',config.strings.included,'ac-gift-label'));
        for (const discount of item.line_level_discount_allocations || []) details.append(node('p', discount.discount_application.title, 'ac-discount'));
        const controls = node('div', undefined, 'ac-controls');
        const label = node('label', config.strings.quantity, 'ac-quantity');
        const quantity = node('input'); quantity.type = 'number'; quantity.min = '0'; quantity.step = '1'; quantity.value = item.quantity; quantity.inputMode = 'numeric'; quantity.dataset.acChange = 'quantity'; quantity.dataset.acKey = item.key;
        quantity.setAttribute('aria-label', config.strings.quantity + ': ' + item.product_title + ', ' + item.variant_title);
        quantity.addEventListener('change', () => {
          const amount = Number(quantity.value);
          if (!quantity.value.trim() || !Number.isSafeInteger(amount) || amount < 0) { quantity.value = item.quantity; return; }
          change(item.key, amount);
        });
        const minus = node('button','−','ac-step'); minus.type='button';minus.dataset.acChange='minus';minus.dataset.acKey=item.key;minus.setAttribute('aria-label',config.strings.decrease+': '+item.product_title);minus.addEventListener('click',()=>change(item.key,item.quantity-1));
        const plus = node('button','+','ac-step'); plus.type='button';plus.dataset.acChange='plus';plus.dataset.acKey=item.key;plus.setAttribute('aria-label',config.strings.increase+': '+item.product_title);plus.addEventListener('click',()=>change(item.key,item.quantity+1));
        label.textContent='';label.append(minus,quantity,plus); if(!gift)controls.append(label);
        const remove = node('button', '⌫', 'ac-remove'); remove.type = 'button'; remove.dataset.acChange = 'remove'; remove.dataset.acKey = item.key; remove.setAttribute('aria-label', config.strings.remove + ': ' + item.product_title + ', ' + item.variant_title); remove.addEventListener('click', () => change(item.key, 0)); controls.append(remove);
        details.append(controls); row.append(details); list.append(row);
      });
      renderExtras(surface,data);
      surface.querySelector('[data-anessa-cart-total]').textContent = money(data.total_price);
      const savings = surface.querySelector('[data-anessa-cart-savings]');
      savings.hidden = !data.total_discount; savings.textContent = config.strings.discounts + ': ' + money(data.total_discount || 0);
      surface.querySelectorAll('[data-anessa-checkout]').forEach(n => n.disabled = busy || !data.items.length);
    });
    status(config.strings.updated);
    document.dispatchEvent(new CustomEvent('anessa:cart-updated', { detail: { cart: data } }));
  }
  async function change(id, quantity) {
    if (busy) { if (currentCart) render(currentCart); return; }
    const focused = document.activeElement;
    const action = focused?.dataset?.acChange;
    const surface = focused?.closest('[data-anessa-cart-surface]');
    lock(true); error();
    try {
      const gift=giftFor(currentCart?.items.find(item=>item.key===id)||{});if(gift && quantity===0)declinedGifts.add(gift.id);
      render(await syncGifts(await request('cart/change.js', { id, quantity })));
    }
    catch (e) { try { render(await request('cart.js')); } catch {} error(e.message || config.strings.error); }
    finally {
      lock(false);
      if (surface && action) {
        const next = [...surface.querySelectorAll('[data-ac-change]')].find(n => n.dataset.acKey === id && n.dataset.acChange === action);
        (next || surface.querySelector('[data-anessa-checkout]:not(:disabled)') || surface.querySelector('a'))?.focus();
      }
    }
  }
  function reveal() {
    if (!drawer || drawer.open) return;
    previousFocus = document.activeElement; savedOverflow = document.documentElement.style.overflow;
    drawer.showModal(); document.documentElement.style.overflow = 'hidden';
  }
  async function open() {
    if (!config) init();
    reveal(); if (busy) return;
    lock(true); error();
    try { render(await syncGifts(await request('cart.js'))); } catch (e) { error(e.message || config.strings.error); } finally { lock(false); }
  }
  async function add(items) {
    if (!config) init();
    if (busy) throw new Error(config.strings.loading);
    lock(true); error();
    try {
      if (items.some(item=>!config.gifts?.some(g=>Number(g.id)===Number(item.id)))) declinedGifts.clear();
      await request('cart/add.js', { items });
      reveal();
      try { render(await syncGifts(await request('cart.js'))); } catch (e) { error(e.message || config.strings.error); }
    } finally { lock(false); }
  }
  function init() {
    const source = document.getElementById('anessa-cart-config'); if (!source) return;
    config = JSON.parse(source.textContent); drawer = document.getElementById('anessa-cart');
    if (drawer && !drawer.dataset.initialized) {
      drawer.dataset.initialized = 'true';
      drawer.querySelector('[data-anessa-cart-close]').addEventListener('click', () => drawer.close());
      drawer.addEventListener('close', () => { document.documentElement.style.overflow = savedOverflow; previousFocus?.focus(); });
      drawer.addEventListener('click', event => { if (event.target === drawer && event.clientX < drawer.getBoundingClientRect().left) drawer.close(); });
    }
    if (document.querySelector('.anessa-cart-page')) openPage();
  }
  async function openPage() {
    if (busy) return; lock(true);
    try { render(await syncGifts(await request('cart.js'))); } catch (e) { error(e.message || config.strings.error); } finally { lock(false); }
  }
  document.addEventListener('click', event => { const trigger = event.target.closest('[data-cart-open]'); if (trigger && document.getElementById('anessa-cart')) { event.preventDefault(); open(); } });
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', event => { if (event.persisted && config) openPage(); });
  window.AnessaCart = { add, open, refresh: openPage };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
